import { useState, useEffect } from 'react'
import { listReports, deleteReport } from '../lib/savedReportsService'

export default function ReportList({ projectId, onSelectReport, onCreateNew }) {
  const [reports, setReports] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => { load() }, [projectId])

  async function load() {
    setLoading(true)
    try {
      const data = await listReports(projectId)
      setReports(data)
    } catch (e) {
      setError(e.message)
    } finally {
      setLoading(false)
    }
  }

  async function handleDelete(id, e) {
    e.stopPropagation()
    if (!window.confirm('Delete this report?')) return
    await deleteReport(id)
    load()
  }

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: '0 auto', fontFamily: 'system-ui' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 800 }}>Analytics Studio</h1>
          <p style={{ fontSize: 12.5, color: '#6B7280' }}>Saved reports for this project</p>
        </div>
        <button onClick={onCreateNew}
          style={{ padding: '9px 18px', background: '#1A7A4A', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
          + New Report
        </button>
      </div>

      {loading && <div style={{ padding: 40, textAlign: 'center', color: '#9CA3AF' }}>Loading…</div>}
      {error && <div style={{ padding: 16, background: '#FEF2F2', borderRadius: 8, color: '#991B1B', fontSize: 13 }}>{error}</div>}

      {!loading && !error && reports.length === 0 && (
        <div style={{ padding: 60, textAlign: 'center', color: '#9CA3AF', fontSize: 13 }}>
          No saved reports yet. Click "New Report" to create one.
        </div>
      )}

      {!loading && reports.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {reports.map(r => (
            <div key={r.id} onClick={() => onSelectReport(r.id)}
              style={{
                background: '#fff', border: '1px solid #E5E7EB', borderRadius: 10, padding: '14px 16px',
                display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer',
              }}>
              <div>
                <div style={{ fontSize: 13.5, fontWeight: 700, color: '#0F1017' }}>{r.presentation?.title || 'Untitled Report'}</div>
                <div style={{ fontSize: 11, color: '#9CA3AF', marginTop: 2 }}>
                  {r.created_by ? `${r.created_by} · ` : ''}
                  Updated {new Date(r.updated_at).toLocaleDateString()}
                </div>
              </div>
              <button onClick={e => handleDelete(r.id, e)}
                style={{ padding: '5px 10px', fontSize: 11, borderRadius: 6, border: '1px solid #FCA5A5', color: '#DC2626', background: '#fff', cursor: 'pointer' }}>
                Delete
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
